import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import { useAppSelector } from "@lib/stores";
import { useAppLiveQuery } from "@modules/local/hooks";
import { db } from "@modules/local/db";
import ContentPageSelector from "../flowTab/ContentPageSelector";
import { useWithContent } from "@modules/content/hooks/useWithContent";
import { useB2BEvents } from "@utils/hooks/useB2BEvents";
import { useIsLoadingVisibile } from "@utils/hooks/useIsLoadingVisible";
import { PageSpinner } from "@components/layouts/content/PageSpinner";
import { Server } from "@wajeez/wajeez.microservices";
import AllahNameDetailsPage from "../ramadan/AllahNameDetailsPage";

export default function DetailsPage() {
  const { contentId } = useParams();

  const [isPageLoading, setIsPageLoading] = useState(false);
  const [pageData, setPageData] =
    useState<Server.CollectionComponentDetailsOutput>();

  const { content, isLoading } = useWithContent(contentId);

  const isLoadingVisible = useIsLoadingVisibile(
    (isLoading && !content) || (isPageLoading && !pageData),
    150
  );

  useB2BEvents();

  const contentTypeId =
    content && content.id === contentId && content?.contentEntityTypeId;

  const userId = useAppSelector((state) => state.auth.user.id ?? "");

  const { result: flow } = useAppLiveQuery(
    () => db.readerFlows.get(userId),
    [userId]
  );

  const navigationPage = useMemo(
    () =>
      flow?.typeNavigations?.find(
        (tnv) => tnv.contentEntityTypeId === contentTypeId
      ),
    [flow, contentTypeId]
  );

  return (
    <div className="relative h-full w-full">
      <div
        className={`absolute left-0 top-0 ${
          isLoadingVisible ? "h-full" : ""
        } z-10 w-full bg-white dark:bg-black`}
      >
        <DetailsPageLoading isLoading={isLoadingVisible} />
      </div>
      {content?.contentEntityType === "ALLAHNAME" && (
        <AllahNameDetailsPage content={content} />
      )}
      <ContentPageSelector
        identifier={navigationPage?.detailsPageType || ""}
        pageId={navigationPage?.detailsPageId || ""}
        context={content && content.id === contentId ? content : undefined}
        onPageLoading={(pageData, isLoading) => {
          setIsPageLoading(isLoading);
          setPageData(pageData);
        }}
      />
    </div>
  );
}

const DetailsPageLoading = ({ isLoading }: { isLoading: boolean }) => {
  return isLoading ? <PageSpinner /> : null;
};
